"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Modal } from "reshaped";
const listener = (e) => {
    const el = e.target;
    let inLegacyModal = false;
    let skipFurtherChecks = false;
    document.querySelectorAll("[role=slider]").forEach((x) => {
        if (x.contains(el))
            skipFurtherChecks = true;
    });
    if (skipFurtherChecks)
        return;
    document.querySelectorAll("[role=presentation]").forEach((x) => {
        if (x.contains(el))
            inLegacyModal = true;
    });
    document.querySelectorAll("#headlessui-portal-root").forEach((x) => {
        if (x.contains(el))
            inLegacyModal = true;
    });
    if (inLegacyModal)
        e.stopPropagation();
};
function BzModal(props) {
    useEffect(() => {
        window.addEventListener("mouseup", listener, { capture: true });
        return () => window.removeEventListener("mouseup", listener);
    }, []);
    return _jsx(Modal, Object.assign({}, props));
}
BzModal.Title = Modal.Title;
BzModal.Subtitle = Modal.Subtitle;
export default BzModal;
